import { downloadPDFsAsZip } from '../../../utils/generatePDF';

/**
 * Downloads one or multiple documents based on the record's file_ids.
 * If multiple files exist, they are downloaded as a zip file.
 * If only one file exists, it is downloaded directly.
 * @function
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.record - The record containing file information
 * @param {Array} params.record.file_ids - Array of file objects containing _id, metadata and contentType
 * @param {Function} params.downloadDocument - Function to download a single document
 * @returns {void}
 */
export const downloadSentDocuments = ({ record, downloadDocument }) => {
  if (record?.file_ids?.length > 1) {
    const blobArray = [];
    record?.file_ids?.map((fileId) => {
      const blob = downloadDocument({
        _id: fileId._id,
        metadata: fileId.metadata,
        contentType: fileId.contentType,
        asZip: true
      });
      return blobArray.push(blob);
    });
    downloadPDFsAsZip(blobArray, 'documents.zip');
  } else {
    downloadDocument({
      _id: record?.file_ids[0]._id,
      metadata: record?.file_ids[0].metadata,
      contentType: record?.file_ids[0].contentType
    });
  }
};
